export const serviceFaqData = [
  {
    name: "What types of services does AREL offer?",
    detail:
      "AREL provides a full suite of real estate services including construction & project management, architectural and interior design, real estate investment solutions, site development, facility management, and expert consultation.",
    active: false,
  },
  {
    name: "Can I invest in AREL projects even if I’m not ready to buy a home yet?",
    detail:
      "AREL ensures 100% transparency, proper legal documentation, and secure transactions for all our investment opportunities. All properties have verified titles and clear ownership structures.",
    active: false,
  },
  {
    name: "Do you offer financing or mortgage options for your properties?",
    detail:
      "Yes, we partner with reputable financial institutions to offer mortgage and asset financing plans. Flexible payment structures are available depending on the property and investment type.",
    active: false,
  },
  {
    name: "What makes AREL’s construction and project management different?",
    detail:
      "We combine quality materials, innovative building techniques, and meticulous planning to deliver durable, premium-standard properties — on time and within budget.",
    active: false,
  },

  {
    name: "How do I book a consultation with AREL?",
    detail:
      "You can book a consultation directly through our website by clicking the “Book a Consultation” button. Choose a convenient time and our team will reach out to guide you through your needs.",
    active: false,
  },
  {
    name: "Can AREL handle my project from start to finish, including land development?",
    detail:
      "Absolutely. Our services cover everything from site preparation and architectural design to construction, finishing, and property marketing or investment structuring.",
    active: false,
  },
];
